import React from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/material";
import img from "../../../assets/images/conheca-seu-cliente.png"
export default function ConhecaSeuCliente() {
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0  sectionInit ">
        <div className="c-init  ">
          <div className="c-init__text col-6  d-flex flex-column sect">
            <p className="fw-bolder text-decoration-underline text-uppercase">
              Conheça Seu Cliente (KYC – Know Your Client)
            </p>

            <p>
              Política elaborada por Marco Dulgheroff Novais (Jurídico) e
              autorizada a publicação pelo Diretor Elson do Nascimento Nunes
              Gusmão, para instrução e adequação dos procedimentos da OM DTVM à
              necessária prevenção e repressão de infrações administrativas e
              legais.
            </p>
          </div>
          <div className="col-6 c-init__images">
            <img src={img} className="images" alt="politica-privacidade"></img>
          </div>
        </div>

        <section>
          <h3>Sumário</h3>
          <ol>
            <li>
              <a href="#sec1">Conformidade e Âmbito de Aplicação</a>
            </li>
            <li>
              <a href="#sec2">Validade e Disponibilização</a>
            </li>
            <li>
              <a href="#sec3">Objetivo deste Procedimento</a>
            </li>
            <li>
              <a href="#sec4">Programa de Prevenção à Lavagem de Dinheiro</a>
            </li>
            <li>
              <a href="#sec5">Dos Princípios</a>
            </li>
            <li>
              <a href="#sec6">Das Diretrizes</a>
            </li>
            <li>
              <a href="#sec7">Papéis e Responsabilidades</a>
            </li>
            <li>
              <a href="#sec8">Definição de Cliente</a>
            </li>
            <li>
              <a href="#sec9">Documentos Solicitados</a>
            </li>
            <li>
              <a href="#sec10">Alterações e Atualização Cadastral</a>
            </li>
            <li>
              <a href="#sec11">Das Balizas de Análise do Risco do Cliente</a>
            </li>
            <li>
              <a href="#sec12">Critérios para a Classificação de Risco</a>
            </li>
            <li>
              <a href="#sec13">Implicações para o Risco Aferido</a>
            </li>
            <li>
              <a href="#sec14">Fixação do Limite Operacional</a>
            </li>
            <li>
              <a href="#sec15">Sistemas Utilizados</a>
            </li>
            <li>
              <a href="#sec16">Guarda de Documentos</a>
            </li>
            <li>
              <a href="#sec17">Sanções Administrativas</a>
            </li>
          </ol>
        </section>

        <section className="mt-5 border p-5" id="sec1">
          <p>
            <ul>
              <li className="fw-bolder text-decoration-underline text-uppercase  mb-3 list-unstyled">
                1. Conformidade e Âmbito de Aplicação
              </li>
              <li className="list-unstyled">
                <p>
                  O procedimento de Conheça Seu Cliente (KYC – Know Your
                  Client), a ser apresentado, está em conformidade com a Lei nº
                  9.613/98
                  <CustomTooltip
                    text='Dispõe sobre os crimes de "lavagem" ou ocultação de bens, direitos e valores; a prevenção da utilização do sistema financeiro para os ilícitos previstos nesta Lei; cria o Conselho de Controle de Atividades Financeiras - COAF, e dá outras providências.'
                    title="¹"
                  />
                  , Lei nº 12.683/12
                  <CustomTooltip
                    title="²"
                    text="Altera a Lei nº 9.613, de 3 de março de 1998, para tornar mais eficiente a persecução penal dos crimes de lavagem de dinheiro."
                  />
                  Lei nº 12.844/13
                  <CustomTooltip
                    title="³"
                    text="Amplia o valor do Benefício Garantia-Safra para a safra de 2011/2012; amplia o Auxílio Emergencial Financeiro, de que trata a Lei nº 10.954, de 29 de setembro de 2004, relativo aos desastres ocorridos em 2012; autoriza a distribuição de milho para venda a pequenos criadores, nos termos que especifica; institui medidas de estímulo à liquidação ou regularização de dívidas originárias de operações de crédito rural; altera as Leis nºs 10.865, de 30 de abril de 2004, e 12.546, de 14 de dezembro de 2011, para prorrogar o Regime Especial de Reintegração de Valores Tributários para as Empresas Exportadoras - REINTEGRA e para alterar o regime de desoneração da folha de pagamentos, 11.774, de 17 de setembro de 2008, 10.931, de 2 de agosto de 2004, 12.431, de 24 de junho de 2011, 12.249, de 11 de junho de 2010, 9.430, de 27 de dezembro de 1996, 10.522, de 19 de julho de 2002, 8.218, de 29 de agosto de 1991, 10.833, de 29 de dezembro de 2003, 9.393, de 19 de dezembro de 1996, 12.783, de 11 de janeiro de 2013, 12.715, de 17 de setembro de 2012, 11.727, de 23 de junho de 2008, 12.468, de 26 de agosto de 2011, 10.150, de 21 de dezembro de 2000, 12.512, de 14 de outubro de 2011, 9.718, de 27 de novembro de 1998, 10.925, de 23 de julho de 2004, 11.775, de 17 de setembro de 2008, e 12.716, de 21 de setembro de 2012, a Medida Provisória nº 2.158-35, de 24 de agosto de 2001, e o Decreto nº 70.235, de 6 de março de 1972; dispõe sobre a comprovação de regularidade fiscal pelo contribuinte; regula a compra, venda e transporte de ouro; e dá outras providências."
                  />
                  ; Lei nº 13.260/16
                  <CustomTooltip
                    title="⁴"
                    text="Regulamenta o disposto no inciso XLIII do art. 5º da Constituição Federal, disciplinando o terrorismo, tratando de disposições investigatórias e processuais e reformulando o conceito de organização terrorista; e altera as Leis n º 7.960, de 21 de dezembro de 1989, e 12.850, de 2 de agosto de 2013."
                  />
                  ; Lei nº 13.810/19
                  <CustomTooltip
                    title="⁵"
                    text="Dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados; e revoga a Lei nº 13.170, de 16 de outubro de 2015."
                  />
                  Circular BCB nº 3.978/20
                  <CustomTooltip
                    title="⁶"
                    text="Dispõe sobre a política, os procedimentos e os controles internos a serem adotados pelas instituições autorizadas a funcionar pelo Banco Central do Brasil visando à prevenção da utilização do sistema financeiro para a prática dos crimes de “lavagem” ou ocultação de bens, direitos e valores, de que trata a Lei nº 9.613, de 3 de março de 1998, e de financiamento do terrorismo, previsto na Lei nº 13.260, de 16 de março de 2016."
                  />
                  ; Carta Circular BCB nº 4.001/20
                  <CustomTooltip
                    title="⁷"
                    text='Divulga relação de operações e situações que podem configurar indícios de ocorrência dos crimes de "lavagem" ou ocultação de bens, direitos e valores, de que trata a Lei nº 9.613, de 3 de março de 1998, e de financiamento ao terrorismo, previstos na Lei nº 13.260, de 16 de março de 2016, passíveis de comunicação ao Conselho de Controle de Atividades Financeiras (Coaf).'
                  />
                  ; Resolução CMN nº 4.968/21
                  <CustomTooltip
                    title="⁸"
                    text="Dispõe sobre os sistemas de controles internos das instituições financeiras e demais instituições autorizadas a funcionar pelo Banco Central do Brasil."
                  />
                  ; Resolução BCB nº 44/20
                  <CustomTooltip
                    title="⁹"
                    text="Estabelece procedimentos para a execução pelas instituições autorizadas a funcionar pelo Banco Central do Brasil das medidas determinadas pela Lei nº 13.810, de 8 de março de 2019, que dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados."
                  />{" "}
                  , Instrução Normativa BCB nº 262/22
                  <CustomTooltip
                    text="Especifica e esclarece aspectos operacionais dos procedimentos estabelecidos na Resolução BCB nº 44, de 24 de novembro de 2020, para a execução de medidas determinadas pela Lei nº 13.810, de 8 de março de 2019, que dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, bem como a designação nacional de pessoas investigadas ou acusadas de terrorismo, seu financiamento ou atos correlacionados."
                    title="¹⁰"
                  />
                  e Resolução ANM nº 129/23.
                  <CustomTooltip
                    title="¹¹"
                    text="Dispõe sobre cumprimento dos deveres de prevenção à lavagem de dinheiro e ao financiamento do terrorismo e da proliferação de armas de destruição em massa - PLD/FTP, legalmente atribuídos na forma dos arts. 10 e 11 da Lei nº 9.613, de 3 de março de 1998."
                  />
                </p>
              </li>
            </ul>
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec2">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              2. Validade e Disponibilização
            </li>
          </ul>
          <p>
            A gestão desta Política (elaboração, conformidade, guarda,
            divulgação, controle de atualizações e adesão) origina-se do
            Programa de Compliance da <b>OM DTVM</b>, de modo que seu conteúdo e
            implementação é de responsabilidade do Diretor da <b>OM DTVM,</b>{" "}
            Elson do Nascimento Nunes Gusmão.
          </p>
          <p>
            Esta política será reavaliada e republicada anualmente, bem como na
            hipótese de quaisquer alterações na <b>OM DTVM</b> ou em razão de
            requerimentos legais e/ou administrativos que justifiquem a
            antecipação.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec3">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              3. Objetivo deste Procedimento
            </li>
          </ul>
          <p>
            Implementar procedimentos destinados a conhecer os Clientes da{" "}
            <b>OM DTVM</b> incluindo aqueles que assegurem a devida diligência
            em sua identificação, qualificação e classificação, em consonância
            àquilo orientado pelo Banco Central do Brasil por meio do Capítulo V
            da Circular nº 3.978/20
            <CustomTooltip
              text="Dispõe sobre a política, os procedimentos e os controles internos a serem adotados pelas instituições autorizadas a funcionar pelo Banco Central do Brasil visando à prevenção da utilização do sistema financeiro para a prática dos crimes de “lavagem” ou ocultação de bens, direitos e valores, de que trata a Lei nº 9.613, de 3 de março de 1998, e de financiamento do terrorismo, previsto na Lei nº 13.260, de 16 de março de 2016."
              title="¹²"
            />{" "}
            e imposto pela Lei nº 9.613/98{" "}
            <CustomTooltip
              title="¹²"
              text='Dispõe sobre os crimes de "lavagem" ou ocultação de bens, direitos e valores; a prevenção da utilização do sistema financeiro para os ilícitos previstos nesta Lei; cria o Conselho de Controle de Atividades Financeiras - COAF, e dá outras providências.'
            />{" "}
            e Resolução CMN nº 4.968/21{" "}
            <CustomTooltip
              title="¹²"
              text="Dispõe sobre os sistemas de controles internos das instituições financeiras e demais instituições autorizadas a funcionar pelo Banco Central do Brasil."
            />
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec4">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              4. Programa de Prevenção à Lavagem de Dinheiro
            </li>
          </ul>
          <p>
            O Programa de Prevenção à Lavagem de Dinheiro e Financiamento ao
            Terrorismo da <b>OM DTVM</b> é essencialmente constituído por 06
            (seis) pilares:
          </p>
          <p>
            <b>(i) </b> Política de Prevenção à Lavagem de Dinheiro e
            Financiamento ao Terrorismo;
          </p>
          <p>
            <b>(ii) </b> Avaliação Interna de Riscos;
          </p>
          <p>
            <b>(iii) </b> Manuais de Procedimentos Operacionais;
          </p>
          <p>
            <b>(iv) </b> Avaliação da Efetividade;
          </p>
          <p>
            <b>(v) </b> Treinamento de Prevenção à Lavagem de Dinheiro e
            Financiamento ao Terrorismo;
          </p>
          <p>
            <b>(vi) </b> Auditoria Interna.
          </p>
          <p>
            Os retromencionados pilares estão em estrita compatibilidade tanto
            às determinações administrativas e legais, quanto à natureza, porte,
            complexidade, estrutura, perfil de risco e modelo de negócio da{" "}
            <b>OM DTVM.</b>
          </p>
          <p>
            Em assim sendo, o Programa de Prevenção à Lavagem de Dinheiro
            (“PLD”), como explorar-se-á adiante, é lastreado em princípios e
            diretrizes que buscam prevenir, mitigar e reprimir os riscos
            relacionados à operação desenvolvida pela <b>OM DTVM</b>.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec5">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              5. Dos Princípios
            </li>
          </ul>
          <p>
            A <b>OM DTVM</b>em sua atuação, busca viabilizar a coibição de
            riscos ao Sistema Financeiro Nacional, bem como coadunar seus
            Correspondentes Cambiais à melhor diligência no processo de
            Prevenção à Lavagem de Dinheiro, Financiamento ao Terrorismo e
            Proliferação de Armas de Destruição em Massa (PLD-FTP).
          </p>
          <p>
            Neste sentido a<b>OM DTVM</b> está empenhada em conduzir os seus
            negócios de forma consistente com os mais elevados padrões éticos e
            em conformidade com todas as leis, regulamentos e normas vigentes e
            aplicáveis, promovendo uma cultura organizacional que repudia
            qualquer ação que possa contribuir para os fins de Lavagem de
            Dinheiro, Financiamento ao Terrorismo e Proliferação de Armas.
          </p>
          <p>
            Em razão disso, a OM DTVM profundamente estatuiu a vedação de sua
            associação e/ou utilização de sua operação como meio de viabilizar
            e/ou facilitar tais atos, realizando, a tal título, extensa
            checagem, gerenciamento e repressão aos riscos suscetíveis ao âmbito
            de sua operação no mercado de câmbio e ouro.
          </p>
          <p>
            A identificação de qualquer indício de Lavagem de Dinheiro e
            Financiamento ao Terrorismo ou qualquer outro ato ilícito, é
            imediatamente comunicada à área de Compliance, que será responsável
            por averiguar as informações reportadas e, no evento de serem
            constatadas, imediatamente comunicar aos órgãos reguladores.
          </p>
          <p>
            A <b>OM DTVM</b> também disponibiliza, em sua rede interna (Intranet
            ou Microsoft Teams), um Canal de Denúncias, o qual é destinado ao
            recebimento anônimo de denúnicas de eventual perpetração de atos
            indevidos, especialmente com relação à Lavagem de Dinheiro,
            Financiamento ao Terrorismo e/ou Proliferação de Armas de Destruição
            em Massa.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec6">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              6. Das Diretrizes
            </li>
          </ul>
          <p>
            A Diretoria da <b>OM DTVM</b> , em seu extenso compromisso de
            aprimorar os controles internos e estabelecer as diretrizes para o
            contínuo fortalecimento das práticas de prevenção de ilícitos,
            definiu 09 (nove) principais diretrizes, as quais estão sendo
            amplamente aplicadas no âmbito da operação da <b>OM DTVM:</b>
          </p>
          <ul>
            <li>
              Proteção à reputação e imagem da <b>OM DTVM</b> através da
              proibição de realização de operações maculadas por indícios de
              crimes de lavagem ou ocultação de bens, direitos e valores, de
              financiamento do terrorismo e/ou proliferação de armas de
              destruição em massa;
            </li>
            <li>
              Desenvolvimento e implementação de políticas, procedimentos e
              controles internos que promovam a efetiva participação da
              comunidade interna em prevenir o uso de produtos e serviços da{" "}
              <b>OM DTVM</b> para a lavagem de dinheiro e financiamento ao
              terrorismo, contribuindo, por assim, para engendrar e enraizar uma
              cultura organizacional de PLD-FT;
            </li>
            <li>
              Estreitar os procedimentos inerentes à identificação, qualificação
              e monitoramento de todos os participantes de sua operação de
              câmbio ou ouro, para o fim de verificar eventual inscrição destes
              perante a lista restritiva do Conselho de Segurança das Nações
              Unidas (CSNU), a qual é constituída por pessoas físicas e/ou
              jurídicas envolvidas em atos ou financiamento de entidades
              terroristas;
            </li>
            <li>
              ornecimento de treinamento adequado e periódico aos funcionários e
              colaboradores de todos os níveis da <b>OM DTVM</b>, especialmente
              àqueles cujo ramo de atuação gera exposição à operações maculadas
              pelo risco de viabilização de atividade ilícita;
            </li>
            <li>
              Avaliação prévia de todos os novos produtos e serviços, bem como o
              emprego de novas tecnologias, para o específico fim de reprimir
              qualquer possibilidade de associação à atividades ilícitas e/ou
              antiéticas;
            </li>
            <li>
              Monitoramento sistêmico de operações visando a lisura das
              operações, bem como da repressão e imediata reprovação/cessação da
              operação em sendo identificados indícios de lavagem de dinheiro e
              financiamento ao terrorismo em consonância com a “Abordagem
              Baseada em Risco” do GAFI;
            </li>
            <li>
              Realização de auditoria interna anual para a verificação da
              aderência e da adequação das políticas, procedimentos e controles
              internos de PLD-FT;
            </li>
            <li>
              Designação, ao Banco Central do Brasil, de diretor responsável
              pela implementação e cumprimento das medidas relacionadas a
              PLD-FT, o qual ficará encarregado de gerenciar e supervisionar a
              aplicação das normas vigentes e dos princípios e diretrizes aqui
              estabelecidos;
            </li>
            <li>
              Condução, de forma sigilosa, dos processos de registro, análise e
              comunicação às autoridades competentes de operações financeiras
              com indícios de lavagem de dinheiro.
            </li>
          </ul>
        </section>

        <section className="mt-5 border p-5" id="sec7">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              7. Papéis e Responsabilidades
            </li>

            <li>
              <p>
                <b>DIRETORIA:</b> Responsável por aprovar as diretrizes do
                Manual de Conheça seu Cliente (KYC) e suas respectivas
                alterações, zelando pela devida implementação dos procedimentos
                e controles regulamentados pela legislação em vigor e, assegurar
                a adoção de melhorias corretivas e preventivas para garantir a
                efetividade do presente Manual.
              </p>
            </li>
            <li>
              <p>
                <b>DIRETOR DE COMPLIANCE:</b> Aprovar o início da relação de
                negócios em caso de insuficiência de informações relativas ao
                processo de qualificação, desde que não haja prejuízo aos
                procedimentos de monitoramento e seleção, bem como aprovar a
                manutenção de Pessoa Exposta Politicamente (PEP) e agentes
                inseridos em monitoramento de especial atenção e, avaliação da
                continuidade do relacionamento relacionada ao descumprimento de
                condições originalmente pactuadas identificadas no processo de
                monitoramento. Responsável pela elaboração, conformidade,
                guarda, divulgação, controle de atualizações, adesão e promoção
                da cultura organizacional de prevenção à lavagem de dinheiro e
                financiamento ao terrorismo; gerenciamento do sistema de
                normativo interno relacionado à Compliance e Controles Internos
                tais como: avaliação interna de risco (AIR), políticas,
                procedimentos, diretrizes, normas e manuais, instruções
                normativas e recomendações institucionais para conformidade do
                negócio; aderência da instituição ao arcabouço legal, à
                regulamentação infralegal, às recomendações dos órgãos de
                supervisão e aos códigos de ética e de conduta, bem como prestar
                suporte a Diretoria Executiva em assuntos relativos à
                Governança, Risco e Compliance – GRC; atender as demandas e
                eventuais auditorias de órgãos reguladores; análise de situações
                reportados pela comunidade interna e canal de denúncia e,
                realizar os procedimentos relacionados a indisponibilidade de
                ativos estabelecida nas Resoluções do CSNU como: determinação a
                execução de bloqueio dos ativos (indisponibilidade para
                transferir, converter, trasladar, disponibilizar os ativos ou
                deles dispor) de titularidade de cliente pessoa física ou
                jurídica identificada como sancionada pelo Conselho de Segurança
                das Nações Unidas e, comunicação ao Banco Central do Brasil, ao
                Ministério da Justiça e Segurança Pública e ao Conselho de
                Controle de Atividade Financeira (COAF) dessa indisponibilidade
                de ativos ou das tentativas de sua transferência, conforme
                disposto no artigo 4º da Resolução BCB nº 44{" "}
                <CustomTooltip
                  title="¹²"
                  text="Estabelece procedimentos para a execução pelas instituições autorizadas a funcionar pelo Banco Central do Brasil das medidas determinadas pela Lei nº 13.810, de 8 de março de 2019, que dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados."
                />{" "}
                de 24 de novembro de 2020.
              </p>
            </li>
            <li>
              <p>
                <b>AUDITORIA INTERNA:</b> Responsável por avaliar e propor
                medidas para aprimoramento e efetividade do Manual: Conheça Seu
                Cliente (KYC) e processos que a <b>OM DTVM</b> estabelece,
                sempre verificando a aderência as regulamentações em vigor e
                aplicabilidade fática.
              </p>
            </li>
            <li>
              <p>
                <b>PLD-FT:</b> Responsável pelo monitoramento tempestivo de
                clientes e operações, mediante a avaliação da capacidade
                econômico financeira visando coerência nos negócios realizados e
                indícios de lavagem de dinheiro e financiamento ao terrorismo;
                implementar processos e procedimentos para identificação,
                monitoramento e análise de comportamentos, operações e/ou
                transações suspeitas de lavagem de dinheiro e financiamento ao
                terrorismo; reportar ao Diretor de Compliance ou Comitê
                Executivo comportamentos, operações e/ou transações suspeitas
                para deliberação; reportar ao COAF/UIF, após a devida
                deliberação, suspeitas de lavagem de dinheiro e financiamento ao
                terrorismo; realizar diligências sempre que necessário em
                clientes, fornecedores e/ou parceiros; inclusão de clientes em
                monitoramento de especial atenção.
              </p>
            </li>
            <li>
              <p>
                <b>ONBOARDING & BACKGROUND CHECK (CADASTRO):</b> Cumprir as
                normas internas e regulamentos vigentes quanto à Avaliação
                Interna de Riscos (AIR) relacionado aos processos de
                identificação, qualificação e classificação dos procedimentos de
                KYC, KYP, KYE e KYS; definir procedimentos para identificação,
                qualificação e obtenção de dados cadastrais visando a
                identificação e conhecimento do cliente bem como garantir o
                atendimento regulatório; definir controles para validação dos
                dados cadastrais declarados pelos clientes; Garantir que o
                cadastro do cliente esteja em conformidade com o status da
                Receita Federal; Identificar o Beneficiário Final dos clientes
                Pessoa Jurídica e, identificar clientes Pessoas Expostas
                Politicamente (PEP), clientes em listas restritivas, clientes
                que residem em região de fronteira ou possuem nacionalidade em
                país considerado sensível para fins de PLD-FT, ou que apresentam
                enquadramento em profissão de risco ou atividades de risco, que
                seguem procedimento particular com a efetivação do processo
                apenas após autorização explicita do Diretor de Compliance.
              </p>
            </li>
            <li>
              <b>TECNOLOGIA DA INFORMAÇÃO: </b>Garantir que os sistemas de
              PLD-FT estejam adequadamente em funcionamento, garantindo a
              resolução de eventuais falhas no menor tempo de resposta possível.
            </li>
          </ul>
        </section>
        <section className="mt-5 border p-5" id="sec8">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              8. DEFINIÇÃO DE CLIENTE
            </li>
          </ul>
          <p>
            Considera-se como “Prospect”, toda pessoa física ou jurídica que
            tenha realizado o cadastro, mas não tenha, efetivamente, utilizado
            um serviço, realizado uma operação ou adquirido um produto.
          </p>
          <p>
            Considera-se como “Cliente Ativo”, toda pessoa física ou jurídica
            que utilizou um serviço, realizou uma operação e/ou adquiriu um
            produto na <b>OM DTVM</b> nos últimos 12 (doze) meses.
          </p>
          <p>
            Considera-se como “Cliente Inativo”, toda pessoa física ou jurídica
            que utilizou um serviço, realizou uma operação e/ou adquiriu um
            produto da <b>OM DTVM </b> em prazo superior à 12 (doze) meses.
          </p>
          <p>
            Considera-se como “Cliente Cadastro Simples”, toda aquela Pessoa
            Física{" "}
            <CustomTooltip
              text="Apenas Cliente Pessoa Física pode ser classificado como “Cadastro Simples”."
              title="¹²"
            />
            ue se amolda aos riscos “baixo” e “médio”, consonante qualificação
            tida no Tópico 12, estando sujeitos ao teor documental listado no
            Tópico 9.1.
          </p>
          <p>
            Considera-se como “Cliente Cadastro Completo”, toda aquela Pessoa
            Física que se amolda ao risco “alto”, consonante qualificação tida
            no Tópico 12, ou Jurídica, estando sujeito ao teor documental
            listado no Tópico 9.2.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec9">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              9. DOCUMENTOS SOLICITADOS
            </li>
          </ul>
          <p>
            Anteriormente ao início do relacionamento da OM DTVM com qualquer
            Cliente, demanda-se a entrega de extensa base documental, a qual
            declinar-se-á adiante:
          </p>
          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>9.1 CADASTRO SIMPLES:</b>
          </h5>
          <p>
            O Cliente classificado como “Cadastro Simples”, necessariamente
            deverá se amoldar aos requisitos adiante declinados:
          </p>

          <p>1) Pessoa Física; e</p>
          <p>
            2) O montante total das operações, somadas nos últimos 12 (doze)
            meses, não ultrapasse o limite de isenção de imposto de renda para
            pessoa física do ano corrente.
          </p>
          <p>
            Para o Cliente “Cadastro Simples”, brasileiro ou residente, deverá a
            base documental adiante declinada ser apresentada:
          </p>
          <p>
            1) Documento de identificação com foto, válido em território
            nacional, como Carteira de Habilitação (CNH), Registro Geral (RG) ou
            Registro no Conselho de Classe; e
          </p>
          <p>
            2) Se o volume operacional dos últimos 12 (doze) meses superar US$
            1.000,00 (mil dólares americanos), o Cliente deverá disponibilizar
            seu comprovante de endereço1.
          </p>
          <p>
            (Pessoa Física Residente no Exterior): Em sendo o Estrangeiro Pessoa
            Física desobrigado de possuir CPF, este deverá disponibilizar o seu
            Passaporte como documento apto a identificação.
          </p>

          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>9.2. CADASTRO COMPLETO:</b>
          </h5>
          <p>
            O Cliente classificado como “Cadastro Completo”, necessariamente
            deverá se amoldar aos requisitos adiante declinados:
          </p>

          <p>1) Pessoa Jurídica; e</p>

          <p>
            2) Pessoa Física com risco aferido em “alto”, inclusive PEP,
            consonante Tópico 12 deste Procedimento.
          </p>

          <p>
            Para o Cliente “Cadastro Completo”, deverá a base documental adiante
            declinada ser apresentada:
          </p>

          <p>1) Pessoa Física:</p>
          <p>
            1.1) Documento de identificação com foto, válido em território
            nacional, como Carteira de Habilitação (CNH), Registro Geral (RG) ou
            Registro no Conselho de Classe;
          </p>
          <p>1.2.) Comprovante de endereço;</p>
          <p>
            1.3.) Extrato de declaração fiscal do ano anterior ou vigente, o que
            for mais próximo; e
          </p>
          <p>
            1.4.) Extratos bancários recentes, que devem totalizar ao menos a
            integralidade do mês anterior ao cadastro.
          </p>

          <p>2) Pessoa Jurídica:</p>
          <p>2.1.) Contrato Social;</p>
          <p>2.2.) Comprovante de endereço; </p>
          <p>
            2.3.) Nome da empresa, endereço da sede e número de identificação ou
            de registro perante respectivo país de origem;
          </p>
          <p>2.4.) Balanço e/ou Balancete; e</p>
          <p>
            2.5.) Declarações fiscais do ano anterior ou vigente, o que for mais
            próximo.
          </p>

          <p>Com relação aos Sócios da Pessoa Jurídica:</p>
          <p>
            Com relação aos Sócios dessa pessoa jurídica, por constituírem os
            beneficiários finais, a todo aquele cuja participação societária
            superar 20% (vinte por cento) das quotas sociais e/ou possuir poder
            de administração, é necessário a entrega de documento de
            identificação com foto, válido em todo território nacional, além do
            comprovante de endereço e recibo e inteiro teor de sua última
            declaração fiscal ou extratos bancários dos últimos 03 (três) meses
            <CustomTooltip
              title="¹²"
              text="Embora não influa diretamente no limite operacional da pessoa jurídica, a análise financeira do Sócio é necessário para maior segurança operacional, haja vista ser necessário a mínima consonância entre o lucro desta e os ganhos do Sócio."
            />
            .
          </p>

          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>9.2.1. FINALIZAÇÃO DO CADASTRO COMPLETO:</b>
          </h5>
          <p>
            Para a finalização do cadastro completo e permissão para a operação,
            o Cliente deverá realizar a assinatura digital de sua Ficha
            Cadastral, a fim de chancelar as informações lá postas.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec10">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              10. ALTERAÇÕES E ATUALIZAÇÃO CADASTRAL
            </li>
          </ul>
          <p>
            Em respeito ao conceito imposto pelo Grupo de Ação Financeira
            Internacional (“GAFI”), a <b>OM DTVM </b> utiliza o Sistema
            E-Guardian para fins de monitoramento dos cadastros e suas possíveis
            alterações de risco, de modo a direcionar para a atualização
            cadastral os “Clientes Ativos” com a mesma base cadastral há mais de
            365 (trezentos e sessenta e cinco) dias.
          </p>
          <p>
            Tal procedimento consiste na reavaliação da categorização do Cliente
            perante a Avaliação Interna de Risco (“AIR”), além disso, promove-se
            a conferência das documentações registradas, para o fim de atestar a
            atualização destas.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec11">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              11. DAS BALIZAS DE ANÁLISE DO RISCO DO CLIENTE
            </li>
          </ul>
          <p>
            Esta <b>OM DTVM</b> em consonância aos arts. 16 ao 18, da Circular
            BCB nº 3.978/20, realiza extenso processo de Identificação e
            Classificação de seus Clientes, para o fim de amoldá-los aos
            conceitos de risco “Baixo”, “Médio” ou “Alto”.
          </p>

          <p>
            Para tanto, esta <b>OM DTVM</b> exige a apresentação de base
            documental, a qual, para pessoas físicas, deverá abranger o nome
            completo, número do Cadastro de Pessoa Física (CPF), lastreados no
            documento de identificação válido, e, se necessário, a declaração de
            imposto de renda, enquanto, para pessoas jurídicas, deverá abranger
            a razão social, número do Cadastro Nacional da Pessoa Jurídica
            (CNPJ), contrato social e/ou atos constitutivos e documento de
            identificação de seus representantes/procuradores e, se necessário,
            seu balanço patrimonial e Demonstrativo de Resultado do Exercício
            (“DRE”).{" "}
          </p>

          <p>
            Disponibilizada a base documental retromencionada, a <b>OM DTVM</b>{" "}
            inicia a validação dos dados do Cliente através do sistema “PH3A”, o
            qual, utilizando API (Application Programming Interface - Interface
            de Programação de Aplicação), identifica a assertividade e
            fidelidade destes, somados aos critérios e diretrizes obtidos e
            definidos na Avaliação Interna de Risco (“AIR”).
          </p>

          <p>
            Além disso, cumpre destacar que a <b>OM DTVM</b> adota procedimento
            adicional de qualificação de seu Cliente, composto pela utilização
            do API para verificação sistêmica de sua eventual adequação ao
            conceito de Pessoa Exposta Politicamente (“PEP”), o que é aferido
            através da utilização dos sistemas “RISC”{" "}
            <CustomTooltip
              title="¹²"
              text=" Plataforma de serviços web para pesquisa de dados reputacionais sobre pessoas físicas e jurídicas, capaz de centralizar as informações para tomada de decisão. As buscas são realizadas em centenas de fontes de informações incluindo, entre outras: Listas PEP e relacionados, Listas Sanções e Restritivas (nacionais e internacionais), Bureau Crédito, Órgãos Reguladores e Autarquias, Fontes Socioambientais. Através da consolidação de uma ampla gama de dados capturados em tempo real e critérios de risco pré-estabelecidos, a ferramenta entrega um relatório inteligente identificando o nível de risco reputacional da parte."
            />{" "}
            e “PH3A”.
          </p>

          <p>
            Para os Clientes classificados como “Risco Alto”, inclusive PEP,
            anteriormente ao início do relacionamento com a OM DTVM, deverá
            ocorrer sua liberação formal mediante aceite de ao menos um membro
            de seu corpo diretivo, o que poderá advir via e-mail de formalização
            e/ou ata de reunião, quando necessário.
          </p>

          <p>
            Em posse de toda a documentação, a <b>OM DTVM</b> baliza o processo
            de classificação de seu Cliente, utilizando os critérios definidos
            no item 12 (Critérios para Classificação de Risco) deste manual.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec12">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              12. CRITÉRIOS PARA A CLASSIFICAÇÃO DE RISCO
            </li>
          </ul>
          <p>
            A fim de aferir o risco de cada Cliente, seja Pessoa Física ou
            Jurídica{" "}
            <CustomTooltip
              title="¹²"
              text="No caso de Clientes Pessoa Jurídica, seus Sócios passarão pelo mesmo processo reputacional, sendo a avaliação do risco da Pessoa Jurídica pautada pela reputação aferida de seus sócios."
            />
            , a OM DTVM impõe a utilização do sistema RISC{" "}
            <CustomTooltip
              title="¹²"
              text=" O Sistema RISC, que deverá ser realizado para todo e qualquer Cliente da OM DTVM, consiste em plataforma de serviços web para pesquisa de dados reputacionais sobre pessoas físicas e jurídicas, capaz de centralizar as informações para tomada de decisão. As buscas são realizadas em centenas de fontes de informações incluindo, entre outras: Listas PEP e relacionados, Listas Sanções e Restritivas (nacionais e internacionais), Bureau Crédito, Órgãos Reguladores e Autarquias, Fontes Socioambientais. Através da consolidação de uma ampla gama de dados capturados em tempo real e critérios de risco pré-estabelecidos, a ferramenta entrega um relatório inteligente identificando o nível de risco reputacional da parte."
            />
            , o qual foi parametrizado com os fatores adiante postos, os quais
            objetivamente calculam cada fator e, para este, atribui uma
            pontuação:
          </p>
          <p>
            A depender do perfil de risco identificado e evolução da relação de
            negócios, a estrutura de Onboarding & Background Check (Cadastro)
            realizará avaliação mais reforçada para situações de maior risco que
            contemplarão o uso do Relatório Reputacional – RISC da Empresa
            Advice Compliance Solutions que, adicionalmente, avalia processos
            judiciais no TRF, TCU, STF, TJ, JF, STJ, CNJ e MPF, mídias negativa
            presentes na internet, listas restritivas nacionais e internacionais
            e listas de sanções nacionais e internacionais
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "left",
                  }}
                >
                  DESCRIÇÃO DA PONTUAÇÃO
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "center",
                  }}
                >
                  PONTUAÇÃO
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["LISTA CSNU", 30],
                ["CPF/CNPJ INATIVO", 30],
                ["PEP – PESSOA EXPOSTA POLITICAMENTE", 10],
                ["LISTA DE SANÇÕES", 10],
                ["CVM – PROCESSOS SANCIONADORES", 10],
                ["ANTECEDENTE CRIMINAL", 10],
                ["CIDADE FRONTEIRA", 10],
                ["INEXISTÊNCIA DE BENEFICIÁRIO FINAL", 10],
                ["MULTAS AMBIENTAIS", 5],
                ["LISTA RESTRITIVA", 5],
                ["PROCESSOS JUDICIAIS", 5],
                ["MÍDIA NEGATIVA", 5],
              ].map(([descricao, pontuacao], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {descricao}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {pontuacao}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>
            Com base na conferência da base documental e análise dos fatores, o
            Sistema RISC automaticamente calcula a pontuação do Cliente,
            conforme escala abaixo:
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #666",
                    padding: "8px",
                    backgroundColor: "#aaa",
                    color: "#003b3f",
                    textAlign: "center",
                  }}
                >
                  RISCO
                </th>
                <th
                  style={{
                    border: "1px solid #666",
                    padding: "8px",
                    backgroundColor: "#aaa",
                    color: "#003b3f",
                    textAlign: "center",
                  }}
                >
                  ESCALA DE PONTOS
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["INACEITÁVEL", "30 ATÉ 99"],
                ["ALTO", "10 ATÉ 29"],
                ["MÉDIO", "05 ATÉ 09"],
                ["BAIXO", "00 ATÉ 04"],
              ].map(([risco, escala], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    {risco}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {escala}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>
            O sistema RISC automaticamente gera um dossiê com a atribuição de
            pontuação e consequente risco de cada Cliente, o qual é
            automaticamente integralizado com o respectivo sistema utilizado
            pela OM DTVM para o desenvolvimento de sua atividade operacional
            (4GL, em sendo ouro, e TravelCash, em sendo câmbio).
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec13">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              13. IMPLICAÇÕES PARA O RISCO AFERIDO
            </li>
          </ul>
          <p>
            A<b>OM DTVM</b>, após classificar o risco de cada Cliente, afere a
            viabilidade da operação e, se positivo, os parâmetros para tanto.
          </p>
          <p>
            <b>INACEITÁVEL</b>
          </p>
          <p>
            A<b>OM DTVM</b>, classifica o possível Cliente como inaceitável
            quando possua envolvimento, transitado em julgado, com crimes
            ambientais relacionados a aquisição ilegal de ouro e/ou lavagem de
            dinheiro e financiamento ao terrorismo, relacionado na Lista CSNU
            (Conselho de Segurança das Nações Unidas) e/ou com situação
            irregular perante a Receita Federal do Brasil (RFB).
          </p>
          <p>
            Em sendo adequado ao conceito de “inaceitável”, o Cliente será
            vetado de realizar quaisquer operações envolvendo a{" "}
          </p>
          <b>OM DTVM</b>.
          <p>
            <b>ALTO RISCO</b>
          </p>
          <p>
            A<b>OM DTVM</b> classifica o possível Cliente como de alto risco
            quando possua envolvimento, não transitado em julgado, com crimes
            ambientais relacionados a aquisição ilegal de ouro e/ou lavagem de
            dinheiro e financiamento ao terrorismo, classificado como Pessoa
            Exposta Politicamente (PEP) ou Organização Não Governamental (ONG),
            com multa ambiental acima de R$ 500.000,00 (quinhentos mil reais);
            relacionado em lista de sanções internacionais, desde que não
            superada a supramencionada métrica de 29 (vinte e nove) pontos.{" "}
          </p>
          <p>
            Neste caso, desde que haja prévia liberação pelo Corpo Diretivo, a{" "}
          </p>{" "}
          <b>OM DTVM</b> libera o Cliente a operar com um limite calculado
          individualmente, com base nos documentos de capacidade
          econômico-financeira apresentados (v. Tópico 9.2.) e reanálise do
          perfil de risco utilizando, impreterivelmente, o Sistema RISC.
          <p>
            <b>MÉDIO RISCO</b>
          </p>
          <p>
            A<b>OM DTVM</b> classifica o possível Cliente como de médio risco
            quando possua envolvimento, transitado em julgado, com crimes não
            relacionados a aquisição ilegal de ouro e/ou lavagem de dinheiro e
            financiamento ao terrorismo, com multa ambiental entre R$ 100.000,00
            (cem mil reais) e R$ 500.000,00 (quinhentos mil reais), que possui
            mídia negativa relacionada a crimes ambientais, aquisição ilegal de
            ouro e/ou lavagem de dinheiro e financiamento ao terrorismo e/ou
            localizado em regiões de fronteira ou de extração mineral, desde que
            não superada a supramencionada métrica de 09 (nove) pontos.{" "}
          </p>
          <p>
            Neste caso, a OM DTVM libera o Cliente a operar com um limite fixo
            pré-aprovado, fixado em consonância ao valor de isenção de
            declaração de imposto de renda.
          </p>
          <p>
            O limite pré-aprovado, entretanto, poderá ser majorado, desde que
            viabilizado por aprovação do Departamento de Compliance e
            apresentada documentação comprobatória de patamar de renda
            consonante ao limite pretendido.
          </p>
          <p>
            <b>BAIXO RISCO</b>
          </p>
          <p>
            A<b>OM DTVM</b> classifica o possível Cliente como de baixo risco
            quando possua envolvimento, não transitado em julgado, com crimes
            não relacionados a aquisição ilegal de ouro e/ou lavagem de dinheiro
            e financiamento ao terrorismo, bem como que, se possuir, que a multa
            ambiental não supere R$100.000,00 (cem mil reais).{" "}
          </p>
          <p>
            Neste caso, a OM DTVM libera o Cliente a operar com um limite fixo
            pré-aprovado, fixado em consonância ao valor de isenção de
            declaração de imposto de renda.
          </p>
          <p>
            Neste caso, a OM DTVM libera o Cliente a operar com um limite fixo
            pré-aprovado, fixado em consonância ao valor de isenção de
            declaração de imposto de renda.
          </p>
          <p>
            O limite pré-aprovado, entretanto, poderá ser majorado, desde que
            viabilizado por aprovação do Departamento de Compliance e
            apresentada documentação comprobatória de patamar de renda
            consonante ao limite pretendido.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec14">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              14. FIXAÇÃO DO LIMITE OPERACIONAL
            </li>
          </ul>
          <p>
            Respeitados os requisitos tidos no “Tópico 13”, a OM DTVM impõe
            escalonada atribuição de limite operacional, o qual necessariamente
            observa os limites postos à cada faixa de risco aferida:
          </p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  colSpan={2}
                  style={{
                    backgroundColor: "#004d1a",
                    color: "#fff",
                    textAlign: "center",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  CLIENTE PESSOA FÍSICA / CADASTRO SIMPLES
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    backgroundColor: "#1a5d2c",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  RISCO BAIXO
                </td>
                <td
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                  }}
                >
                  R$ 33.000,00
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    backgroundColor: "#1a5d2c",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  RISCO MÉDIO
                </td>
                <td
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                  }}
                >
                  R$ 33.000,00
                </td>
              </tr>
            </tbody>
          </table>

          <table
            style={{
              width: "100%",
              marginTop: "24px",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  colSpan={2}
                  style={{
                    backgroundColor: "#004d1a",
                    color: "#fff",
                    textAlign: "center",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  CLIENTE PESSOA FÍSICA / CADASTRO COMPLETO
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    backgroundColor: "#1a5d2c",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  RISCO BAIXO
                </td>
                <td
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                  }}
                >
                  70% do rendimento declarado no IRPF; ou <br />
                  100% do valor imediatamente líquido.
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    backgroundColor: "#1a5d2c",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  RISCO MÉDIO
                </td>
                <td
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                  }}
                >
                  70% do rendimento declarado no IRPF; ou <br />
                  100% do valor imediatamente líquido.
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    backgroundColor: "#1a5d2c",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  RISCO ALTO
                </td>
                <td
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                  }}
                >
                  Limite personalizado de acordo com o Perfil de cada Cliente.
                </td>
              </tr>
            </tbody>
          </table>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  colSpan={2}
                  style={{
                    backgroundColor: "#004d1a",
                    color: "#fff",
                    textAlign: "center",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  CLIENTE PESSOA JURÍDICA
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    backgroundColor: "#1a5d2c",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid #999",
                    width: "30%",
                  }}
                >
                  RISCO BAIXO
                </td>
                <td
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                  }}
                >
                  70% do faturamento declarado em ECF/Contábil; ou
                  <br />
                  100% do ativo líquido declarado em Balanço/Balancete.
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    backgroundColor: "#1a5d2c",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  RISCO MÉDIO
                </td>
                <td
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                  }}
                >
                  70% do faturamento declarado em ECF/Contábil; ou
                  <br />
                  100% do ativo líquido declarado em Balanço/Balancete.
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    backgroundColor: "#1a5d2c",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid #999",
                  }}
                >
                  RISCO ALTO
                </td>
                <td
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                  }}
                >
                  Limite personalizado de acordo com o Perfil de cada Cliente.
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <section className="mt-5 border p-5" id="sec15">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              15. SISTEMAS UTILIZADOS
            </li>
          </ul>
          <p>
          <b>Travelcash</b>: Plataforma Financeira para operações de câmbio (turismo, comercial e MoneyGram)<CustomTooltip title="¹" text="A liberação das operações realizadas na plataforma Moneygram, ocorre somente dentro do Travelcash Gerencial, plataforma em apartado que funciona através de configurações específicas." />.

          </p>

          <p><b>PH3A</b>Utilizado pelo sistema TravelCash e 4GL para autenticação de dados, como Cadastro de Pessoa Física (CPF) e Cadastro Nacional de Pessoa Jurídica (CNPJ)<CustomTooltip title="¹" text="A PH3A é um sistema voltado à consulta junto a Receita federal e, utilizamos no 4GL e Travelcash através de API (conector em sistemas heterogêneos), sendo que todos os Clientes da OM DTVM, independentemente de sua posição de risco, passam por verificação de autenticidade de seus dados."/>;</p>

          <p><b>Agent Connect:</b> API homologada pela MoneyGram, cuja finalidade é realizar as operações de remessas internacionais.</p>
          <p><b>RISC</b> Sistema informatizado que gera um dossiê reputacional daquele Cliente Pessoa Física ou Jurídica, indicando a existência de restrições judiciais e administrativas, bem como a qualidade de PEP. Com relação a Pessoa Jurídica, o sistema ainda é capaz de identificar os beneficiários finais das transações (“sócios”).</p>
          <p><b>FX Vuori: </b>Realização de pagamento de boletos, PIX e QRcode, bem como de conciliação bancária (automática ou manual), sendo a manual dependente da atuação de um agente do backoffice para realizar a liberação <CustomTooltip text="A Vuori é uma empresa voltada para soluções de Open Finance - o sistema FX é responsável pelos robôs que realizam o envio da mensageira ao Bacen (registro das operações de câmbio), bem como integra o Travelcash ao sistema bancário (STR), surgindo uma terceira figura neste processo financeiro." title="¹"/></p>
          <p><b>SyLog: </b>Impressão de etiquetas de delivery e conferência de extrato de acompanhamento de entrega.</p>
          <p><b>Ouro 4GL:</b> Plataforma financeira para a realização de operações de ouro (Mesa, Varejo, Site e App).</p>
        </section>

        <section className="mt-5 border p-5" id="sec16">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              16. GUARDA DE DOCUMENTOS
            </li>
          </ul>
          <p>
           A <b>OM DTVM</b> garante a guarda de todas as informações de todas as informações relacionadas com suas operações de ouro e câmbio pelo prazo de 10 (dez) anos.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec17">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              17. SANÇÕES ADMINISTRATIVAS
            </li>
          </ul>
          <p>
           A <b>OM DTVM</b> , com o escopo de preservar a legalidade e assertividade de suas operações, desenvolveu um protocolo de sanções e penalidades a serem aplicadas em face de qualquer participante de sua operação, em caso de descumprimento das regulações do Banco Central do Brasil ou de qualquer outra legislação aplicável.
          </p>
          <p>Nessa toada, no evento de ser cometida alguma irregularidade, ao tomar ciência, a <b>OM DTVM</b>  instaurará um procedimento interno para apuração dos fatos, do que decorrerá a constatação de eventual ocorrência e gravidade da conduta. </p>
          <p>Verificada a ocorrência e apurada a gravidade, a  <b>OM DTVM</b> aplicará as sanções proporcionalmente, as quais são constituídas por advertência por ofício, advertência formal, suspensão temporária do contrato ou rescisão contratual motivada, sem prejuízo da aplicação de multas contratuais por tal razão. </p>
        </section>
      </section>
    </article>
  );
}

const CustomTooltip = (props: { title: string; text: string }) => {
  return (
    <>
      <Tooltip title={props.text} placement="top-start">
        <sup>
          <Button style={{ margin: 0, padding: 0, minWidth: "0px" }}>
            {props.title}
          </Button>
        </sup>
      </Tooltip>
    </>
  );
};
